import { StarDecoration } from "../star-decoration"

export function FooterStars() {
  return (
    <>
      <div className="absolute left-[5%] top-[25%] md:left-[35%] md:top-[50%]">
        <StarDecoration width={38} height={38} />
      </div>
      <div className="absolute bottom-[-2%] right-[0%] md:right-[0%] md:top-[0%]">
        <StarDecoration width={26} height={26} />
      </div>
    </>
  )
}
